<template>
<div>
  <v-btn :disabled="disabled" color="medium_blue" :loading="loading" @click="fetch" text><v-icon class="mr-2">fas fa-file-export</v-icon> Exportar</v-btn>
  <v-dialog v-model="dataReady" max-width="500">
    <v-card>
      <v-card-title>
        <h1 class="text text-h5 titulo"><v-icon class="mr-2">fas fa-download</v-icon>Exportar</h1>
      </v-card-title>
      <v-card-text class="text-center">
        <vue-json-to-csv
          :json-data="workOrders"
          :labels="labels"
          :csv-title="csvTitle"
          :separator="';'"
          @success="val => handleSuccess(val)"
          @error="val => handleError(val)">
          <v-btn color="success">
            <v-icon class="mr-2">fas fa-download</v-icon> <b>Lista</b>
          </v-btn>
        </vue-json-to-csv>
        <vue-json-to-csv
          :json-data="products"
          class="ml-2"
          :labels="detailLabels"
          :csv-title="'detalle_'+csvTitle"
          :separator="';'"
          @success="val => handleSuccess(val)"
          @error="val => handleError(val)">
          <v-btn color="success">
            <v-icon class="mr-2">fas fa-download</v-icon> <b>Detalle</b>
          </v-btn>
        </vue-json-to-csv>
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import notifications from '@/utils/notifications'
import {fetchPostCostWorkOrders,} from '@/api/reports'
import VueJsonToCsv from 'vue-json-to-csv'
import moment from 'moment'
import numeral from 'numeral'
export default {
  name:"ExportPostCost",
  props:['filter','options','disabled','search'],
  components: {VueJsonToCsv,},
  data() {
    return {
      loading: false,
      workOrders:[],
      products:[],
      dataReady:false,
      labels:{ 
        id:{title:'Nro'},
        created_at:{title:'Creada'},
        completed_at:{title:'Finalizada'},
        name: { title: 'Proyecto' },
        sales_note:{title:'Cotización'},
        customer_name:{title:'Cliente'},
        customer_tipo:{title:'Tipo Cliente'},
        customer_industry:{title:'Industria'},
        customer_rubro:{title:'Rubro'},
        seller_full_name:{title:'Vendedor'},
        seller_bussiness_unit:{title:'Unidad de Negocio'},
        sales_total:{title:'Venta'},
        sales_cost:{title:'Costo Teórico'},
        estimated_margin:{title:'Margen Teórico'},
        total:{title:'Costo Real'},
        real_margin:{title:'Margen Real'},
        production_cost:{title:'Costo de Producción'},
        reprocess_cost:{title:'Costo de Reproceso'},
        consume_cost:{title:'Costo de Consumo Producción'},
        consume_cost_reprocess:{title:'Costo de Consumo Reproceso'},
        additional_costs:{title:'Costo Adicional'},
        purchase_orders_costs:{title:'Costo de Ordenes de Compra'},
        warehouse_consumption:{title:'Costo de Consumo de Bodega'},
       },
       detailLabels:{
        id:{title:'OT'},
        created_at:{title:'Creada'},
        completed_at:{title:'Finalizada'},
        name: { title: 'Proyecto' },
        sales_note:{title:'Cotización'},
        customer_name:{title:'Cliente'},
        seller_full_name:{title:'Vendedor'},
        sku:{title:'SKU'},
        product_name:{title:'Producto'},
        line:{title:'Linea'},
        family:{title:'Familia'},
        qty:{title:'Cantidad'},
        mts2:{title:'Mts2'},
        total_price:{title:'Precio Total'},
        teoric_cost:{title:'Costo Teórico'},
        real_cost:{title:'Costo Real'},
       },
       csvTitle:`export_postcost_report_${moment(new Date().toISOString()).format('DD-MM-yyyy_HH:mm')}`
    }
  },
  methods:{
    async fetch(){
      this.loading=true
      var created_before = ''
      var created_after = ''
      if(this.filter.created_after) created_after = moment(this.filter.created_after).utc().format('yyyy-MM-DD HH:mm')
      if(this.filter.created_before) created_before=moment(this.filter.created_before).utc().add(1439,'minutes').format('yyyy-MM-DD HH:mm')
      
      var customer = this.filter.customer?.id || ''

      const {sortBy, sortDesc,page, itemsPerPage }=this.options
      const query=`ordering=${sortDesc[0]?sortBy[0]:'-'+sortBy[0]}&search=${this.search}&page=1&created_after=${created_after}&created_before=${created_before}&sales_note__customer=${customer}&completed=true`
      this.workOrders=[]
      this.products=[]
      await fetchPostCostWorkOrders(query)
      .then((data)=>{
        this.totalWorkOrders=data.count
        this.workOrders = data.results.map(item=>{
          const {additional_costs,
          warehouse_consumption, 
          consume_cost,
          consume_cost_reprocess,
          production_cost,
          reprocess_cost,
          purchase_orders_costs,
          sales_cost, sales_total, total,products} = item.real_price
          item.created_at=moment(item.created_at).format('DD-MM-yyyy HH:mm')
          item.completed_at=moment(item.completed_at).format('DD-MM-yyyy HH:mm')
          item.estimated_margin=sales_total!=0?(1-sales_cost/sales_total)*100:0
          item.real_margin=total!=0?(1-sales_cost/total)*100:0
          item.seller_bussiness_unit=item.seller_bussiness_unit||''
          
          products.forEach(product=>{ 
            this.products.push({...product,...item})
          })
        
          return {...item,additional_costs, consume_cost, consume_cost_reprocess,production_cost,reprocess_cost, purchase_orders_costs, sales_cost, sales_total, total,warehouse_consumption}
        })
        this.dataReady=true
      })
      .catch((err)=>notifications.showError('Error Cargando Ordenes de Trabajo' + err))
      .finally(()=>this.loading=false)
    },
    handleSuccess(val){
      console.log(val)
      notifications.showSuccess('Ordenes de Trabajo Exportadas')
      this.dataReady=false
    },
    handleError(val){
      console.log(val)
      notifications.showError('Error Exportando Ordenes de Trabajo')
      this.dataReady=false
    }
  }

}
</script>